import { render, staticRenderFns } from "./textAlertPopup.vue?vue&type=template&id=501e1124&scoped=true"
import script from "./textAlertPopup.vue?vue&type=script&lang=js"
export * from "./textAlertPopup.vue?vue&type=script&lang=js"
import style0 from "./textAlertPopup.vue?vue&type=style&index=0&id=501e1124&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501e1124",
  null
  
)

export default component.exports